import data from "../../../../../packages/react/src/Dialog.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};